<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>
                Administration
            </h1>
            <ul class="sidebar-menu">
                <li class="header">MAIN NAVIGATION</li>


                <li v-if="fullAdmin >= 30">
                    <router-link to="/servers-data">
                        <i class="fa fa-gear"></i> <span>Informations</span>
                    </router-link>
                </li>
                <li v-if="fullAdmin >= 40">
                    <router-link to="/sql">
                        <i class="fa fa-gear"></i> <span>SQL Execute</span>
                    </router-link>
                </li>
                <li v-if="fullAdmin >= 20">
                  <router-link to="/chats/history">
                    <i class="fa fa-comments"></i> <span>Chat History</span>
                  </router-link>
                </li>
                <li>
                    <router-link to="/admin-chat">
                        <i class="fa fa-comments"></i> <span>Admin Chat</span>
                    </router-link>
                </li>
                <li>
                    <router-link to="/chats" v-if="fullAdmin >= 20">
                        <i class="fa fa-comments"></i> <span>Chats</span>
                    </router-link>
                </li>

                <li v-if="fullAdmin >= 33">
                    <router-link to="/users">
                        <i class="fa fa-user"></i> <span>Users</span>
                    </router-link>
                </li>
                <li v-if="fullAdmin >= 33">
                  <a href="/analytic">
                    <i class="fa fa-google"></i> <span>Analytic</span>
                  </a>
                </li>
                <li v-if="fullAdmin >= 40">
                  <a href="/block-analytics">
                    <i class="fa fa-google"></i> <span>Block Analytics</span>
                  </a>
                </li>
                <li v-if="fullAdmin >= 33">
                    <router-link to="/ban">
                        <i class="fa fa-ban"></i> <span>Ban</span>
                    </router-link>
                </li>
                <li v-if="fullAdmin >= 30">
                  <router-link to="/facebook-switch">
                    <i class="fa fa-user"></i> <span>Facebook merge</span>
                  </router-link>
                </li>

                <li v-if="fullAdmin >= 30">
                    <router-link to="/coins">
                        <i class="fa fa-money"></i> <span>Coins</span>
                    </router-link>
                </li>
                <li>
                    <router-link to="/skins">
                        <i class="fa fa-picture-o"></i> <span>Skins</span>
                    </router-link>
                </li>

                <li>
                    <router-link to="/private-skins">
                        <i class="fa fa-picture-o"></i> <span>Private skins</span>
                    </router-link>
                </li>

                <li>
                    <router-link to="/skins-managment">
                        <i class="fa fa-picture-o"></i> <span>New skins <span class="label label-info">{{ waitSkins
                        }}</span></span>
                    </router-link>
                </li>
                <li>
                    <router-link to="/private-skins-managment">
                        <i class="fa fa-picture-o"></i> <span>New private skins <span
                            class="label label-info">{{ waitPrivateSkins }}</span></span>
                    </router-link>
                </li>

            </ul>
        </section>
        <section class="content">
            <div class="row">
                <div class="col-lg-3 col-xs-6">
                    <!-- small box -->
                    <div class="small-box bg-aqua">
                        <div class="inner">
                            <h3>{{number_of_skins}}</h3>
                            <p>Skinova</p>
                        </div>
                        <div class="icon">
                            <i class="fa fa-photo"></i>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-xs-6">
                    <!-- small box -->
                    <div class="small-box bg-red">
                        <div class="inner">
                            <h3>{{number_of_private_skins}}</h3>
                            <p>Privatnih skinova</p>
                        </div>
                        <div class="icon">
                            <i class="fa fa-photo"></i>
                        </div>
                    </div>
                </div>
                <!--&lt;!&ndash; ./col &ndash;&gt;-->
                <!--<div class="col-lg-3 col-xs-6">-->
                    <!--&lt;!&ndash; small box &ndash;&gt;-->
                    <!--<div class="small-box bg-green">-->
                        <!--<div class="inner">-->
                            <!--<h3>53<sup style="font-size: 20px">%</sup></h3>-->

                            <!--<p>Bounce Rate</p>-->
                        <!--</div>-->
                        <!--<div class="icon">-->
                            <!--<i class="ion ion-stats-bars"></i>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
                <!-- ./col -->
                <!--<div class="col-lg-3 col-xs-6">-->
                    <!--&lt;!&ndash; small box &ndash;&gt;-->
                    <!--<div class="small-box bg-yellow">-->
                        <!--<div class="inner">-->
                            <!--<h3>44</h3>-->
                            <!--SELECT COUNT(id) AS fb FROM `users` WHERE `facebook_id` IS NULL OR `facebook_id` LIKE ''-->
                            <!--<p>User Registrations</p>-->
                        <!--</div>-->
                        <!--<div class="icon">-->
                            <!--<i class="ion ion-person-add"></i>-->
                        <!--</div>-->
                        <!--<a href="#" class="small-box-footer">-->
                            <!--More info <i class="fa fa-arrow-circle-right"></i>-->
                        <!--</a>-->
                    <!--</div>-->
                <!--</div>-->
                <!-- ./col -->
                <div class="col-lg-3 col-xs-6">
                    <!-- small box -->
                    <div class="small-box bg-red">
                        <div class="inner">
                            <h3>{{number_of_users}}</h3>

                            <p>Registrovanih igrača</p>
                        </div>
                        <div class="icon">
                            <i class="ion ion-pie-graph"></i>
                        </div>
                    </div>
                </div>
                <!-- ./col -->
            </div>
            <!-- /.row -->
        </section>
    </div>
</template>

<script>
    export default {
      name: 'dashboardHome',
      data: function () {
        return {

          number_of_users: 0,
          number_of_private_skins: 0,
          number_of_skins: 0,
          form: new Form({}),
          fullAdmin: 0
        }
      },
      mounted: function () {
        var self = this
        this.fullAdmin = this.$store.state.role
        this.form.post(baseUrl + 'Admin/agarStructure').then(function (result) {
          self.number_of_skins = result.info.number_of_skins
          self.number_of_private_skins = result.info.number_of_private_skins
          self.number_of_users = result.info.number_of_users
        }, function (reason) {})
        // this.form.post(baseUrl + 'Skins/numberOfWaitingPrivateSkins').then(function (result) {
        //   self.waitPrivateSkins = result
        // }, function (reason) {})
      }
    }
</script>

<style scoped>
    @media screen and (min-width: 768px) {
        .content-header {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// dashboard.vue?7bf6323a